var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";

import SubscribeButton from "../../../components/Library/SubscribeButton";

import styles from "./Subscribing.css";

var Subscribing = function (_Component) {
  _inherits(Subscribing, _Component);

  function Subscribing(props) {
    _classCallCheck(this, Subscribing);

    var _this = _possibleConstructorReturn(this, (Subscribing.__proto__ || Object.getPrototypeOf(Subscribing)).call(this, props));

    _this.onChange = function (event) {
      _this.setState(_defineProperty({}, event.target.name, event.target.value));
    };

    _this.state = {
      email: ""
    };
    return _this;
  }

  _createClass(Subscribing, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var subscription = this.props.subscription;

      if (!subscription) return null;

      return React.createElement(
        "div",
        null,
        React.createElement(
          "div",
          { className: styles.content },
          React.createElement(
            "div",
            { className: styles.text },
            "Great choice. Enter your email to subscribe to ",
            React.createElement(
              "strong",
              null,
              subscription.name
            ),
            "."
          ),
          React.createElement("input", {
            name: "email",
            "aria-label": "Enter Your Email Address",
            className: styles.input,
            placeholder: "Your Email Address",
            value: this.state.email,
            onChange: this.onChange
          })
        ),
        React.createElement(
          SubscribeButton,
          {
            className: styles.subscribe,
            disabled: this.state.email === "",
            onClickSubscribe: function onClickSubscribe() {
              return _this2.props.onSubscribe(_this2.state.email);
            } },
          "Submit"
        )
      );
    }
  }]);

  return Subscribing;
}(Component);

export default Subscribing;


// WEBPACK FOOTER //
// ./src/author/components/Subscribing/Subscribing.js